/* eslint-disable import/no-unresolved */
import React, { useRef } from 'react';
import { navigate } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { motion } from 'framer-motion';
import { Autoplay, Pagination } from 'swiper';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import Icons from '../layouts/Icons';

export default function HomeBanner({ data }) {
  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };

  return (
    <section
      className="relative top-0 h-screen z-20 overflow-hidden border-b border-black"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <Swiper
        loop
        ref={swiperRefLocal}
        autoplay={{ delay: 6000 }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper relative swiper-pagination:!hidden swiper-pagination:3xl:!left-[160px]
        swiper-pagination:!left-[80px] swiper-pagination:!w-auto
        swiper-pagination:lg:!flex swiper-pagination:!items-center
        swiper-pagination:!bottom-[70px] swiper-pagination-bullet:!bg-white
        swiper-pagination-bullet:!w-[12px] swiper-pagination-bullet:!h-[12px]
        swiper-pagination-bullet:!opacity-100 swiper-pagination-bullet:!mx-[10px]
        swiper-pagination-bullet-active:!w-[18px] swiper-pagination-bullet-active:!h-[18px]">
        {isEmpty(data) ||
          data.map((item, index) => {
            const { title } = item.content;
            const { subtitle } = item.content;
            const { link } = item.content;

            return (
              <SwiperSlide
                key={index}
                className={`relative before:!inline before:content-[''] before:absolute before:top-0
                before:w-full before:h-screen before:bg-black before:bg-opacity-40 before:z-10
                !h-screen ${link ? 'cursor-pointer' : ''}`}
                onClick={() => {
                  if (link) navigate(link.url);
                }}>
                {isEmpty(item.content.image) || (
                  <LazyLoadImage
                    src={item.content.image.url}
                    alt={`${title} ${subtitle}`}
                    className="w-full !h-screen object-cover lg:object-center object-left"
                  />
                )}
                {!item.content.videoUrl || (
                  <iframe
                    src={item.content.videoUrl}
                    title="about intro video"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowFullScreen
                    className="w-screen h-screen min-h-[100vh] min-w-[177.77vh] object-cover
                  absolute select-none top-1/2 right-0 bottom-1/2 left-0 -translate-y-1/2"
                  />
                )}
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.8 }}
                  className="absolute top-0 flex flex-col justify-center items-center h-full w-full
                3xl:pt-0 lg:pt-[50px] pt-24 z-15">
                  <div
                    className="text-center flex flex-col items-center lg:gap-y-[68px]
                  gap-y-[85px]">
                    <h2
                      className="flex flex-col 4xl:text-5xl 3xl:text-4xl lg:text-[75px]
                      lg:leading-[86px] text-[55px] font-roboto-condensed-bold uppercase
                      text-white">
                      <span
                        className="2xl:tracking-[8px] xl:tracking-[7px] lg:tracking-[4px]
                      tracking-[1px]">
                        {title}
                      </span>
                      <span
                        className="bg-white bg-opacity-90 text-red 3xl:tracking-[13px]
                        xl:tracking-[11px] lg:tracking-[7px] md:tracking-[3px] tracking-[1px]
                        relative before:content-[''] before:!inline  before:absolute
                        before:lg:-bottom-10 before:-bottom-[75px] before:left-1/2 before:h-10
                        before:w-[2px] before:bg-white pl-6 pr-5">
                        {subtitle}
                      </span>
                    </h2>
                    <p
                      className="text-white xl:text-base text-[15px] tracking-[0.8px]
                      font-roboto-regular text-center 2xl:max-w-[633px] max-w-[500px]
                      flex flex-col lg:gap-y-5 gap-y-3 items-center leading-7 md:px-0 px-2">
                      {item.content.text}
                      <Icons icon="arrow-head" className="!block w-[12px]" />
                    </p>
                  </div>
                </motion.div>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </section>
  );
}
